import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { Tooltip, VirtualList } from "components"
import LinkSpecificationSearch from "./LsSearch"
import classes from "./LsCategories.module.scss"

const LsCategories = props => {
  const {
    categories,
    selectedCategory,
    setSelectedCategory
  } = props
  
  const [t] = useTranslation()

  const [cats, setCats] = useState(categories)

  const handleSearch = (search) => {
    setCats(
      categories.filter(c => c.name.includes(search))
    )
  }

  const handleSelectCategory = (categoryId) => {
    setSelectedCategory(prev =>
      prev === categoryId ? "" : categoryId
    )
  }

  return (
    <div className={classes["container"]}>
      <LinkSpecificationSearch
        delay={0}
        placeholder={t("جست_و_جوی")}
        onSearch={handleSearch}
      />
      <VirtualList
        keyField="_id"
        data={cats}
        itemHeight={28}
        className={classes["list"]}
        listEmptyComponent={
          <div className={classes["no"]}>
            {t("هیچ_دسته_بندی_یافت_نشد")}
          </div>
        }
        renderItem={(category) =>
          <div
            onClick={() => handleSelectCategory(category._id)}
            className={clsx(
              classes["category"],
              selectedCategory === category._id && classes["active"]
            )}
          >
            <Tooltip
              title={category.name}
            >
              <div className={classes["category-name"]}>
                {category.name}
              </div>
            </Tooltip>
          </div>
        }
      />
    </div>
  )
}

export default LsCategories